/**
 * Hello Greeting Client Mod — 注册器
 *
 * 通过 DI 获取 UI Registry 服务，注册：
 * - 页面路由（/greetings）
 * - 全局状态（greetings atoms）
 * - 组件（GreetingList）
 * - Hook（useGreetings）
 */
import { greetingsAtom, greetingsLoadingAtom, greetingsErrorAtom } from './state.js';
import { GreetingList } from './components/greeting-list.js';
import { useGreetings } from './hooks/use-greetings.js';
export class HelloGreetingRegistrar {
    constructor(deps) {
        const { pageRouteRegistry, globalStateRegistry, componentRegistry, hooksRegistry, } = deps;
        // ─── 1. 注册页面路由 ───
        pageRouteRegistry.registerPage({
            path: '/greetings',
            component: GreetingList,
            key: 'hello-greeting-list',
            meta: {
                title: 'Greetings',
                requiresAuth: false,
            },
            modName: 'hello-greeting-client',
            // SSR 数据预取：服务端渲染期间执行此 loader 获取初始数据
            // 在 SSR 环境中，通过 request.url 构建绝对 URL 以发起 API 请求
            // 在 CSR 环境中，fetch 会自动使用当前 origin
            loader: async ({ request }) => {
                const apiUrl = request
                    ? new URL('/api/greetings', request.url).toString()
                    : '/api/greetings';
                const res = await fetch(apiUrl);
                if (!res.ok) {
                    throw new Error(`Failed to load greetings: HTTP ${res.status}`);
                }
                return res.json();
            },
        });
        // ─── 2. 注册全局状态 ───
        globalStateRegistry.registerStates('hello-greeting-client', {
            greetings: greetingsAtom,
            greetingsLoading: greetingsLoadingAtom,
            greetingsError: greetingsErrorAtom,
        });
        // ─── 3. 注册可复用组件 ───
        componentRegistry.registerComponents('hello-greeting-client', {
            GreetingList,
        });
        // ─── 4. 注册 Hooks ───
        hooksRegistry.registerHooks('hello-greeting-client', {
            useGreetings,
        });
    }
}
//# sourceMappingURL=hello-greeting-registrar.js.map